import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { StatsBlock } from '../common/stats-block'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  children: React.ReactNode
} & ClassNameProps

export const AvgBuyMcDistributionCommon = (props: Props) => {
  const { t } = useTranslation()
  return (
    <StatsBlock
      className={props.className}
      header={
        <StatsBlock.Header>
          <StatsBlock.Title>
            {t('profile.avg_buy_mc_distribution')}
          </StatsBlock.Title>
          <HeaderValue>
            {t('common.count')}&nbsp;<HeaderSeparator>/</HeaderSeparator>&nbsp;%
          </HeaderValue>
        </StatsBlock.Header>
      }
    >
      {props.children}
    </StatsBlock>
  )
}

const HeaderValue = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--text-11);
`
const HeaderSeparator = styled.span`
  color: var(--text-9);
`
